type AnalyticsValue = string | number | boolean;

type AnalyticsData = Record<string, AnalyticsValue>;

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: AnalyticsData) => void;
    };
  }
}

/**
 * Privacy-conscious Umami event helper. Analytics is optional, so calls are
 * deliberately silent when the script is not configured or has not loaded.
 */
export function track(event: string, data?: AnalyticsData): void {
  if (typeof window === "undefined" || !window.umami) return;

  try {
    window.umami.track(event, data);
  } catch {
    // Analytics must never interrupt a clinician-facing workflow.
  }
}
